import React, { useState } from "react";
import "./Textarea.scss";

export type InputProps = {
  name: string;
  errorText: string;
  formError: boolean;
  validationFunc?: (input: string) => boolean;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  children?: any;
  autoComplete?: string;
};

const Textarea = React.forwardRef((props: InputProps, ref: React.LegacyRef<HTMLTextAreaElement>) => {
  const [isError, setIsError] = useState(false);

  const handleOnBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if (props.validationFunc) {
      let validationResult = props.validationFunc(e.currentTarget.value);
      setIsError(!validationResult);
    }

    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  const handleChange = (e: any) => {
    setIsError(false);
    props.onChange(e);
  };

  return (
    <>
      <div className="textarea-input">
        <textarea
          placeholder=" "
          autoComplete={props.autoComplete}
          id={props.name}
          ref={ref}
          className={isError || props.formError ? "input-error" : ""}
          onBlur={handleOnBlur}
          onChange={handleChange}
        />
        <label htmlFor={props.name}>{props.name}</label>
        {props.children}
      </div>

      {(isError || props.formError) && <div className="error-message">{props.errorText}</div>}
    </>
  );
});

export default Textarea;
